// @flow
import React from 'react'
import Helmet from 'react-helmet'
import { Switch, Route } from 'react-router'

import { type Route as RouteObjectType } from './constants/routes'

import { isClient } from './services/getRenderPlatform'

// Types
type Props = {
  routes: Array<RouteObjectType>
}

const COMMIT = process.env.COMMIT || 'N.A.'
const VERSION = process.env.VERSION || 'N.A.'

/* istanbul ignore next */
if (process.env.NODE_ENV !== 'test' && isClient) {
  console.info(`
    __            __        _                __   __
     | |  | |\\ | / _\` |    |__  |\\/| | |\\ | |  \\ /__\`
  \\__/ \\__/ | \\| \\__> |___ |___ |  | | | \\| |__/ .__/

  by: Jungle Minds
  Version: ${VERSION}
  Commit: ${COMMIT}
  `)
}

// eslint-disable-next-line react/display-name
const renderRoute = Component => (props: *) => <Component {...props} />

export const RouteWithSubRoutes = (route: RouteObjectType) => (
  <Route path={route.path} render={renderRoute(route.component)} />
)

const App = ({ routes }: Props) => (
  <div>
    <Helmet titleTemplate="%s - Basic Project" />
    <Switch>
      {routes.map((route, i) => {
        // only pass allowed route props to Route component
        const { ...routeProps } = route
        return <RouteWithSubRoutes key={i} {...routeProps} />
      })}
    </Switch>
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js